import PaymentLink from "./PaymentLink";
import QRCode from "./QRCode";

export default class InitiatePaymentResponse {

    constructor(json) {
        this.transmissionDateTime = json['transmissionDateTime'];
        this.referenceKey = json['referenceKey'];
        this.qrCodePayment = new QRCode(json['qrCodePayment']);
        this.responseCode = json['responseCode'];
        this.responseDescription = json['responseDescription'];

        this.appPaymentLinks = [];
        json['appPaymentLinks'].forEach((link) => {
            this.appPaymentLinks.push(new PaymentLink(link))
        })

        this.webPaymentLinks = [];
        json['webPaymentLinks'].forEach((link) => {
            this.webPaymentLinks.push(new PaymentLink(link))
        })
    }
}